import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { setLangList, setLangDetails } from "../../redux/actions/actions";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Input from "./Input";
import Select from "./Select";
import Textarea from "./Textarea";
import { useTranslation } from "react-multi-lang";
import "./form.css";
import { query } from "../../api/queries";
import { useQuery, useMutation } from "@apollo/client";
import { setLanguage } from "react-multi-lang";
import { Helmet } from "react-helmet-async";

import Footer from "../footer/Footer";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
function Form() {
  const t = useTranslation();
  const [languageList, setLanguageList] = useState([]);
  const location = useLocation();
  const dispatch = useDispatch();
  const { languageId, locale } = useSelector((state) => state.lng);
  const [cityId, setCityId] = useState(0);
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState({
    firstName: "",
    sureName: "",
    email: "",
    phone: "",
    title: "",
    time: "",
    country: "",
    city: "",
    boutique: "",
  });
  const [formData, setFormData] = useState({
    firstname: "",
    salutation: "",
    lastname: "",
    phone: "",
    customerEmail: "",
    boutiqueId: 0,
    remark: "",
    languageId: languageId,
  });

  const { loading, data } = useQuery(query.COUNTRIES_QUERY);
  const {
    loading: languageLoading,
    data: languages,
    error,
  } = useQuery(query.LANGUAGE_QUERY);
  useEffect(() => {
    if (!error && !languageLoading) {
      setLanguageList(languages.appointmentlanguages);
      dispatch(setLangList(languages.appointmentlanguages));
    }
  }, [languages, error, languageLoading]);
  const [countryId, setcountryId] = useState(0);

  const { loading: cityLoading, data: dataCity } = useQuery(
    query.CITIES_QUERY,
    {
      variables: { countryId },
    }
  );

  const { loading: boutiquesLoading, data: dataBoutiques } = useQuery(
    query.BOUTIQUES_QUERY,
    {
      variables: { cityId, languageId: 1 },
    }
  );

  useEffect(() => {
    setCityId(0);
    setcountryId(0);
    setFormData({ ...formData, boutiqueId: 0 });
    setMessage("");
    setErrors({
      firstName: "",
      sureName: "",
      email: "",
      phone: "",
      title: "",
      time: "",
      country: "",
      city: "",
      boutique: "",
    });
  }, [languageId]);

  useEffect(() => {
    if (location.search !== "") {
      let lng = location.search.replace("?lang:", "");
      setLanguage(lng);
      if (languageList.length > 0) {
        dispatch(
          setLangDetails({
            languageName: lng,
            languageId: languageList.find((item) => item.code === lng).id,
          })
        );
      }
    }
  }, [languageList]);

  const [create] = useMutation(query.ADD_APPOINTMENT_SIGNUP, {
    onCompleted(data) {
      setFormData({
        firstname: "",
        salutation: "",
        lastname: "",
        phone: "",
        customerEmail: "",
        boutiqueId: 0,
        remark: "",
        languageId: languageId,
      });
      setMessage(t("response.success"));
      setcountryId(0);
      setCityId(0);
      setSubmitting(false);
      setOpen(true);
    },
  });

  const onSubmit = () => {
    setMessage("");
    setErrors({
      firstName: "",
      sureName: "",
      email: "",
      phone: "",
      title: "",
      time: "",
      country: "",
      city: "",
      boutique: "",
    });
    let errors = {};
    if (formData.firstname === "") {
      errors.firstName = t("error.Firstname");
    }
    if (formData.lastname === "") {
      errors.sureName = t("error.Surname");
    }
    if (formData.salutation === "") {
      errors.title = t("error.Title");
    }
    if (formData.customerEmail === "") {
      errors.email = t("error.Email");
    }
    if (formData.phone === "") {
      errors.phone = t("error.Phone");
    }

    if (!validateEmail(formData.customerEmail)) {
      errors.email = t("error.EmailValid");
    }
    if (cityId === 0) {
      errors.city = t("error.City");
    }
    if (countryId === 0) {
      errors.country = t("error.Country");
    }
    if (formData.boutiqueId === 0) {
      errors.boutique = t("error.BoutiqueId");
    }

    if (isEmpty(errors)) {
      setSubmitting(true);
      create({
        variables: formData,
      });
    } else {
      setErrors(errors);
    }
  };
  function isEmpty(obj) {
    for (var prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        return false;
      }
    }

    return JSON.stringify(obj) === JSON.stringify({});
  }
  function validateEmail(email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  const [open, setOpen] = useState(false);
  const onCloseModal = () => setOpen(false);
  return (
    <>
      <Helmet>
        <title> Montblanc Boutique {t("home.Title")}</title>
      </Helmet>
      <Modal open={open} onClose={onCloseModal} center>
        <div className="modal-content">
          <p>
            <strong>{t("response.successTitle")}</strong>
          </p>
          <p>{t("response.successDescription")}</p>
        </div>
      </Modal>
      <div className="top-box">
        <h1> {t("home.Title")}</h1>
      </div>
      <div className={`form-box ${submitting ? "blur" : ""}`}>
        <div className="form-box-title">
          <h4 className="form-description uppercase">{`${t(
            "form.SelectBoutique"
          )}`}</h4>
          {t("form.FormTitle")}
        </div>
        <div className="form-termi">
          <div className="mandatory">*{`${t("form.RequiredText")}`}</div>

          <Select
            label={`${t("form.Country")}*`}
            placeholder={t("general.PleaseSelect")}
            options={loading ? [] : data ? data.appointmentcountries : []}
            onChange={(e) => {
              setcountryId(e.target.value);
            }}
            error={errors?.country}
            value={countryId}
          />
          <Select
            label={`${t("form.City")}*`}
            placeholder={t("general.PleaseSelect")}
            options={
              cityLoading ? [] : dataCity ? dataCity.appointmentcities : []
            }
            onChange={(e) => {
              setCityId(e.target.value);
            }}
            error={errors?.city}
          />
          <Select
            label={`${t("form.Boutique")}*`}
            placeholder={t("general.PleaseSelect")}
            error={errors?.boutique}
            options={
              boutiquesLoading
                ? []
                : dataBoutiques
                ? dataBoutiques.appointmentboutiques.map((item) => ({
                    id: item.id,
                    defaultName: item.name,
                  }))
                : []
            }
            onChange={(e) => {
              setFormData({ ...formData, boutiqueId: e.target.value });
            }}
          />
        </div>
        <div className="form-description">
          <div className="form-box-title">
            <h4 className="form-description uppercase gray">{`${t(
              "form.Details"
            )}`}</h4>
          </div>
          <Select
            label={`${t("form.Title")}*`}
            placeholder={t("general.PleaseSelect")}
            options={[
              {
                value: 1,
                defaultName: t("general.Mr"),
              },
              {
                value: 2,
                defaultName: t("general.Mrs"),
              },
              {
                value: 3,
                defaultName: t("general.Ms"),
              },
            ]}
            value={formData.salutation}
            onChange={(e) => {
              setFormData({ ...formData, salutation: e.target.value });
            }}
            error={errors?.title}
          />
          <Input
            label={`${t("form.Fullname")}*`}
            type="text"
            error={errors?.firstName}
            value={formData.firstname}
            onChange={(e) => {
              setFormData({ ...formData, firstname: e.target.value });
            }}
          />
          <Input
            label={`${t("form.Surname")}*`}
            error={errors?.sureName}
            value={formData.lastname}
            onChange={(e) => {
              setFormData({ ...formData, lastname: e.target.value });
            }}
          />
          <Input
            label={`${t("form.Email")}*`}
            error={errors?.email}
            value={formData.customerEmail}
            onChange={(e) => {
              setFormData({ ...formData, customerEmail: e.target.value });
            }}
          />
          <div className="phone-wrapper form-group">
            <label>{`${t("form.Phone")}*`}</label>
            <PhoneInput
              placeholder={`${t("form.PhonePlaceholder")}`}
              value={formData.phone}
              onChange={(value) => {
                setFormData({ ...formData, phone: value });
              }}
            />
            {errors?.phone && <div className="error">{errors?.phone}</div>}
          </div>
          <Textarea
            label={`${t("form.MessageText")}`}
            placeholder={`${t("form.MessagePlaceHolder")}`}
            onChange={(e) => {
              setFormData({ ...formData, remark: e.target.value });
            }}
            value={formData.remark}
          />
        </div>
        <div className="privacy">
          <p>{`${t("terms.text1")}`}</p>
          <p>{`${t("terms.text2")}`}</p>
          <p>
            {`${t("terms.text3")}`}
            <a
              href={`https://www.montblanc.com/${locale}/Help/LegalArea/PrivacyPolicy`}
            >{`${t("terms.privacy")}`}</a>
            {`${t("terms.text4")}`}
          </p>
        </div>
        <div className="form-group">
          <button
            className="submit-btn"
            onClick={() => onSubmit()}
            disabled={submitting}
          >
            {`${t("form.SubmitText")}`}
          </button>
        </div>
      </div>

      <Footer locale={locale} />
    </>
  );
}

export default Form;
